const assets = {
    images: {
      logo: require("./images/DishLogoBlockTrimmed.jpg")
    }
  };
  
  export default assets;